// extracted by mini-css-extract-plugin
module.exports = {"spinner":"loader_spinner__jg8pM","sk-bouncedelay":"loader_sk-bouncedelay__O-kok","bounce1":"loader_bounce1__229gv","bounce2":"loader_bounce2__3Eu5k"};